import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SHARED_MODULES } from 'src/app/modules/shared-imports';
import { LegalAgreeComponent } from '../legal-agree/legal-agree.component';

/**
 * Shown before an invitation is accepted from a notification (bell or notifications page). That path used to join the
 * company with no agreement at all; now the person ticks "I agree to the Terms of Service and Privacy Policy" first, and
 * the server records every published document only when that tick was sent (never without it).
 *
 *   <app-invite-accept-dialog [visible]="x" [busy]="b" (confirmed)="accept()" (cancelled)="x = false"></app-invite-accept-dialog>
 */
@Component({
  selector: 'app-invite-accept-dialog',
  standalone: true,
  imports: [SHARED_MODULES, LegalAgreeComponent],
  template: `
    <p-dialog [visible]="visible" [modal]="true" [draggable]="false" [resizable]="false" appendTo="body" [baseZIndex]="25000"
              [style]="{ width: '92vw', 'max-width': '440px' }" [header]="'invite.acceptTitle' | t" (visibleChange)="onVisible($event)">
      <p class="m-0 mb-3">{{ 'invite.acceptText' | t }}</p>
      <app-legal-agree [(checked)]="agreed" [attempt]="attempts"></app-legal-agree>
      <ng-template pTemplate="footer">
        <p-button [label]="'common.cancel' | t" styleClass="p-button-text" [disabled]="busy" (click)="cancelled.emit()"></p-button>
        <p-button icon="pi pi-check" [label]="'invite.acceptButton' | t" [loading]="busy" (click)="go()"></p-button>
      </ng-template>
    </p-dialog>
  `,
})
export class InviteAcceptDialogComponent {
  @Input() visible = false;
  @Input() busy = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  agreed = false;
  attempts = 0;

  onVisible(v: boolean): void {
    if (!v) { this.cancelled.emit(); }
    else { this.agreed = false; }
  }

  go(): void {
    if (!this.agreed) { this.attempts++; return; }
    this.confirmed.emit();
  }
}
